import { GenericObject, copyFields, fixDates } from '@synergy/models';
import { Media } from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { Customer } from '../../../common/models/customer';
import { DemandAccountItem } from './demand-account-item';
import { DemandAccountStatus } from './demand-account-status';

export class DemandAccount {
    public id?: number;
    public status!: DemandAccountStatus;
    public emailSentDate?: Date;
    public demandAccountItems!: DemandAccountItem[];
    public customerAccount!: Customer;
    public customerContact!: Contact;
    public media!: Media[];
    public internalNote!: string;
    public note!: string;
    public updatedAt?: Date;

    public static fromPlainObject(object: GenericObject): DemandAccount {
        const demandAccount = new DemandAccount();

        copyFields(object, demandAccount);

        if (object['customerAccount']) {
            demandAccount.customerAccount = Customer.fromPlainObject(object['customerAccount']);
        }

        if (object['customerContact']) {
            demandAccount.customerContact = Contact.fromPlainObject(object['customerContact']);
        }

        demandAccount.media = object['media']?.map(Media.fromPlainObject) ?? [];

        if (object['emailSentDate']) {
            demandAccount.emailSentDate = new Date(object['emailSentDate']);
        }

        fixDates(demandAccount, ['updatedAt']);

        return demandAccount;
    }
}
